import { PdpCatalogSalesStatus } from '../../graphql/select-option_types.2';
import { ItemCardState, OptionInfo, ProductOptionConfig } from '../../type/common.type';
import { hasRequiredFieldInCustomInputOptions } from '../../util/checkers/custom-input-field-checker';
import { productMetadataBuilder } from '../../util/transformers/product-metadata-transformer';
import { buildItemCard } from '../item-card.core';

/**
 * 자동 선택 가능한 아이템 카드를 생성하여 반환합니다.
 */
export const createAutoSelectedItemCard = ({
  optionInfo,
  productMetadata,
  config,
}: {
  optionInfo: OptionInfo;
  productMetadata: ReturnType<typeof productMetadataBuilder>;
  config?: ProductOptionConfig;
}): ItemCardState | null => {
  // 자동 선택이 불가능한 경우들
  const cannotAutoSelect =
    config?.disableSingleOptionAutoSelect ||
    !optionInfo.catalog_product.matched_item_list.length ||
    Boolean(optionInfo.catalog_product.promotion_info?.bogo_info?.required_quantity);

  const onSaleItemList = optionInfo.catalog_product.matched_item_list.filter(
    (item) => item.sales_status === PdpCatalogSalesStatus.ON_SALE,
  );
  const firstOnSaleItem = onSaleItemList[0];
  // 자동 추가 조건: 선택 가능하고, 판매 중인 조합 가능 아이템이 1개뿐이고, 필수 입력형 옵션이 없는 경우
  const shouldAutoAdd =
    !cannotAutoSelect &&
    onSaleItemList.length === 1 &&
    !hasRequiredFieldInCustomInputOptions(optionInfo.catalog_product.custom_input_option_list ?? []);

  if (shouldAutoAdd) {
    return buildItemCard({
      item_cards: { list: [], total_count: 0 },
      selected_item: firstOnSaleItem,
      custom_input_list: [],
      context: {
        bogo_info: productMetadata.bogo_info,
        maxPurchaseQuantity: config?.maxPurchaseQuantity,
        min_order_quantity: productMetadata.min_order_quantity,
        is_order_quantity_product_type: productMetadata.is_order_quantity_product_type,
        is_order_quantity_item_type: productMetadata.is_order_quantity_item_type,
        is_store_deal_banner: productMetadata.has_store_deal_banner,
        enableSingleItemSelection: config?.enableSingleItemSelection,
      },
    });
  }

  return null;
};
